import { AccessControl, useImpersonation } from '@cmg/auth';
import {
  AppBar as DesignSystemAppBar,
  AppBarLogo,
  AppBarNavigationMenu,
  ImpersonationBanner,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@cmg/design-system';
import React, { VFC } from 'react';

import Logo from '../../../common/assets/cmg-xc-logo.svg';
import { AppBarSecondarySection } from './AppBarSecondarySection';
import { useNavItems } from './hooks';
import { TopLevelItems } from './TopLevelItems';

export const AppBar: VFC = () => {
  const navItems = useNavItems();
  const impersonation = useImpersonation();

  return (
    <React.Fragment>
      {impersonation.isImpersonating && (
        <ImpersonationBanner
          impersonatedUsername={impersonation.impersonatedUsername}
          impersonationMode={impersonation.impersonationMode}
        />
      )}
      <AccessControl>
        <DesignSystemAppBar
          logoSection={<AppBarLogo imgSrc={Logo} imgAlt="CMG XC Logo" />}
          navigationSectionLinks={<TopLevelItems navItems={navItems} />}
          navigationSectionMenu={
            <AppBarNavigationMenu
              label="Main Menu"
              renderItems={({ closeMenu }) =>
                navItems.map(navDefinition => (
                  <ListItem
                    disablePadding
                    role="menuitem"
                    key={navDefinition.id}
                    onClick={closeMenu}
                  >
                    <ListItemButton href={navDefinition.href} target={navDefinition.target}>
                      <ListItemText primary={navDefinition.label} />
                    </ListItemButton>
                  </ListItem>
                ))
              }
            />
          }
          secondarySection={<AppBarSecondarySection />}
        />
      </AccessControl>
    </React.Fragment>
  );
};
